import React from "react";
import { FindMoreTimesButton } from "./FindMoreTimesButton";
import { Message } from "./QuickRescheduleMessage";
import { QuickRescheduleOption } from "./QuickRescheduleOption";
import { getLabelTextFromISO } from "./util/getLabelTextFromISO";

type Props = {
  confirmationMessage?: string;
  confirming?: boolean;
  emphasis?: boolean;
  errorMessage?: string;
  loading?: boolean;
  onConfirm: () => void;
  onFindMoreTimes: () => void;
  onHover?: (startISO: string | null) => void;
  onSelect: (selectedISO: string | null) => void;
  options?: string[];
  value?: string | null;
};

export const QuickReschedule = ({
  confirmationMessage = "",
  confirming = false,
  emphasis = false,
  errorMessage = "",
  loading = false,
  onConfirm,
  onFindMoreTimes,
  onHover,
  onSelect,
  options = [],
  value = null,
}: Props) => {
  return (
    <div className="cw-body-base">
      <div className="cw-flex cw-flex-col cw-space-y-2">
        {errorMessage && <Message sentiment="warning">{errorMessage}</Message>}
        {confirmationMessage && <Message sentiment="info">{confirmationMessage}</Message>}
        {loading ? (
          <>
            <QuickRescheduleOption loading disabled />
            <QuickRescheduleOption loading disabled />
            <QuickRescheduleOption loading disabled />
          </>
        ) : (
          <>
            {options.map((option, index) => {
              const state = option === value ? (confirming ? "confirming" : "selected") : "default";
              const toggleSelected = () => onSelect(option === value ? null : option);
              const handleHover = (hovered: boolean) => onHover?.(hovered ? option : null);
              const text = getLabelTextFromISO(option);

              return (
                <QuickRescheduleOption
                  disabled={confirming}
                  emphisis={emphasis}
                  key={index}
                  onConfirm={onConfirm}
                  onHover={handleHover}
                  onSelect={toggleSelected}
                  state={state}
                  text={text}
                />
              );
            })}
          </>
        )}
        <FindMoreTimesButton disabled={confirming} emphisis={emphasis} onClick={onFindMoreTimes} />
      </div>
    </div>
  );
};
